import {
  ArrayInput,
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DateField,
  DateInput,
  Edit,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectField,
  SelectInput,
  Show,
  SimpleForm,
  SimpleFormIterator,
  SimpleShowLayout,
  TextField,
  TextInput,
} from "react-admin";
import { StringArrayField } from "./CustomFields";
import {
  budgetTypeList,
  jobOpeningStatusList,
  openingTypeList,
} from "../../types";

const openingTypeChoices = openingTypeList.map((type) => ({
  id: type,
  name: type,
}));
const budgetTypeChoices = budgetTypeList.map((type) => ({
  id: type,
  name: type,
}));
const statusChoices = jobOpeningStatusList.map((type) => ({
  id: type,
  name: type,
}));

const filters = [
  <ReferenceInput key="company" source="company" reference="companies" />,
  <TextInput key="role" source="role" />,
  <SelectInput
    key="opening_type"
    source="opening_type"
    choices={openingTypeChoices}
  />,
  <SelectInput key="status" source="status" choices={statusChoices} />,
  <TextInput key="scope_time" source="scope_time" />,
  <TextInput
    key="scope_engagement_duration"
    source="scope_engagement_duration"
  />,
  <DateInput key="desired_start_date" source="desired_start_date" />,
  <DateInput key="created_at" source="created_at" />,
];

export const JobOpeningList = () => (
  <List filters={filters}>
    <Datagrid>
      <ReferenceField source="company" reference="companies" />
      <TextField source="role" />
      <TextField source="job_description_link" />
      <SelectField source="opening_type" choices={openingTypeChoices} />
      <SelectField source="status" choices={statusChoices} />
      <TextField source="scope_time" />
      <TextField source="scope_engagement_duration" />
      <SelectField source="budget_type" choices={budgetTypeChoices} />
      <NumberField source="budget_min_cents" />
      <NumberField source="budget_max_cents" />
      <TextField source="budget_notes" />
      <DateField source="desired_start_date" />
      {/* <StringArrayField source="match_criteria" />
      <TextField source="short_description" />
      <TextField source="note_for_venturous" /> */}
      <BooleanField source="show_anonymous_candidates" />
      <BooleanField source="allow_candidate_bidding" />
      <DateField source="created_at" />
    </Datagrid>
  </List>
);

export const JobOpeningShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField source="company" reference="companies" />
      <TextField source="role" />
      <TextField source="job_description_link" />
      <SelectField source="opening_type" choices={openingTypeChoices} />
      <SelectField source="status" choices={statusChoices} />
      <TextField source="scope_time" />
      <TextField source="scope_engagement_duration" />
      <SelectField source="budget_type" choices={budgetTypeChoices} />
      <NumberField source="budget_min_cents" />
      <NumberField source="budget_max_cents" />
      <TextField source="budget_notes" />
      <DateField source="desired_start_date" />
      <StringArrayField source="match_criteria" />
      <TextField source="short_description" />
      <TextField source="deliverables" />
      <TextField source="goals" />
      <TextField source="note_for_venturous" />
      <BooleanField source="show_anonymous_candidates" />
      <BooleanField source="allow_candidate_bidding" />
      <DateField source="created_at" />
    </SimpleShowLayout>
  </Show>
);

export const JobOpeningCreate = () => (
  <Create>
    <SimpleForm>
      <ReferenceInput source="company" reference="companies" />
      <TextInput source="role" />
      <TextInput source="job_description_link" />
      <SelectInput source="opening_type" choices={openingTypeChoices} />
      <SelectInput source="status" choices={statusChoices} />
      <TextInput source="scope_time" />
      <SelectInput source="budget_type" choices={budgetTypeChoices} />
      <TextInput source="scope_engagement_duration" />
      <NumberInput source="budget_min_cents" min={0} step={1} />
      <NumberInput source="budget_max_cents" min={0} step={1} />
      <TextInput source="budget_notes" />
      <DateInput source="desired_start_date" />
      <ArrayInput source="match_criteria">
        <SimpleFormIterator>
          <TextInput source="" multiline />
        </SimpleFormIterator>
      </ArrayInput>
      <TextInput source="short_description" multiline />
      <TextInput source="deliverables" multiline />
      <TextInput source="goals" multiline />
      <TextInput source="note_for_venturous" multiline />
      <BooleanInput source="show_anonymous_candidates" />
      <BooleanInput source="allow_candidate_bidding" />
      <DateInput source="created_at" />
    </SimpleForm>
  </Create>
);

export const JobOpeningEdit = () => (
  <Edit>
    <SimpleForm>
      <ReferenceInput source="company" reference="companies" />
      <TextInput source="role" />
      <TextInput source="job_description_link" />
      <SelectInput source="opening_type" choices={openingTypeChoices} />
      <SelectInput source="status" choices={statusChoices} />
      <TextInput source="scope_time" />
      <TextInput source="scope_engagement_duration" />
      <NumberInput source="budget_min_cents" min={0} step={1} />
      <NumberInput source="budget_max_cents" min={0} step={1} />
      <TextInput source="budget_notes" />
      <DateInput source="desired_start_date" />
      <ArrayInput source="match_criteria">
        <SimpleFormIterator>
          <TextInput source="" multiline />
        </SimpleFormIterator>
      </ArrayInput>
      <TextInput source="short_description" multiline />
      <TextInput source="deliverables" multiline />
      <TextInput source="goals" multiline />
      <TextInput source="note_for_venturous" multiline />
      <BooleanInput source="show_anonymous_candidates" />
      <BooleanInput source="allow_candidate_bidding" />
      <DateInput source="created_at" />
    </SimpleForm>
  </Edit>
);
